import type { CSSProperties, FC, ReactNode } from 'react';

import { CancelButton, FooterContent, SubmitButton } from '../styles/dashboard';

export const Footer: FC<{
  onCancel: () => void;
  onSubmit: () => void;
  disabled: boolean;
  titleSubmit: ReactNode;
  titleCancel?: ReactNode;
  disabledCancel?: boolean;
  style?: CSSProperties;
  buttonOrder?: 'submitFirst' | 'cancelFirst';
}> = ({
  onCancel,
  onSubmit,
  disabled,
  titleSubmit,
  titleCancel,
  disabledCancel,
  style,
  buttonOrder = 'submitFirst',
}) => {
  return (
    <FooterContent style={style}>
      {buttonOrder === 'submitFirst' ? (
        <>
          <SubmitButton
            variant="contained"
            color="primary"
            type="submit"
            size="medium"
            onClick={onSubmit}
            disabled={disabled}
            style={{
              marginRight: 12,
              fontSize: '16px',
              lineHeight: '22px',
              fontWeight: 600,
              height: 44,
              padding: '0 24px',
            }}
          >
            {titleSubmit}
          </SubmitButton>
          <CancelButton
            variant="outlined"
            type="submit"
            size="medium"
            onClick={onCancel}
            disabled={disabledCancel}
          >
            {titleCancel || 'Cancel'}
          </CancelButton>
        </>
      ) : (
        <>
          <CancelButton
            variant="outlined"
            type="submit"
            size="medium"
            onClick={onCancel}
            disabled={disabledCancel}
            style={{ marginRight: 12 }}
          >
            {titleCancel || 'Cancel'}
          </CancelButton>
          <SubmitButton
            variant="contained"
            color="primary"
            type="submit"
            size="medium"
            onClick={onSubmit}
            disabled={disabled}
            style={{
              fontSize: '16px',
              lineHeight: '22px',
              fontWeight: 600,
              height: 44,
              padding: '0 24px',
            }}
          >
            {titleSubmit}
          </SubmitButton>
        </>
      )}
    </FooterContent>
  );
};
